"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Prismic = function Prismic(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.83 3.866H6.785a2.915 2.915 0 0 0-2.92 2.92v8.553a7.912 7.912 0 0 0 3.13 1.043 1.965 1.965 0 0 1-.21-.835V8.663c-.104-.104-.104-2.607 1.044-4.797zM20.24 7.829V6.786a2.915 2.915 0 0 0-2.92-2.92H8.872A7.912 7.912 0 0 0 7.83 6.995c.21-.209.522-.209.835-.209h6.78c.104 0 2.607 0 4.797 1.043zm-4.067 12.412h1.043a2.915 2.915 0 0 0 2.92-2.92V8.871a7.912 7.912 0 0 0-3.13-1.043c.21.209.21.521.21.834v6.78c0 .104 0 2.607-1.043 4.798zM3.761 16.173v1.043a2.915 2.915 0 0 0 2.92 2.92h8.448a7.912 7.912 0 0 0 1.043-3.129c-.208.209-.521.209-.834.209H8.56c-.104 0-2.607 0-4.797-1.043zM13.253.007h-7.51C2.614.007.007 2.614.007 5.743c0 0 .209 5.528 2.399 8.135.104.209.313.313.521.522V6.682a3.85 3.85 0 0 1 3.86-3.86h1.668c.313-.417.626-.73.939-1.042.939-.73 2.399-1.356 3.86-1.773zM23.996 13.253v-7.51c0-3.129-2.607-5.736-5.736-5.736 0 0-5.528.208-8.136 2.398a1.257 1.257 0 0 0-.521.522h7.718a3.85 3.85 0 0 1 3.859 3.859v1.669c.417.313.73.626 1.043.939.73.938 1.356 2.398 1.773 3.859zM10.75 23.995h7.51c3.128 0 5.736-2.607 5.736-5.736 0 0-.209-5.528-2.399-8.135-.104-.209-.313-.313-.521-.522v7.718a3.85 3.85 0 0 1-3.86 3.86h-1.668c-.313.417-.626.73-.939 1.042-.939.73-2.399 1.356-3.86 1.773zM.007 10.75v7.509c0 3.129 2.607 5.736 5.736 5.736 0 0 5.528-.208 8.136-2.398.208-.105.313-.313.521-.522H6.786a3.85 3.85 0 0 1-3.859-3.859v-1.669c-.417-.313-.73-.626-1.043-.939C1.05 13.67.424 12.21.007 10.75z"
  }));
};

Prismic.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Prismic.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Prismic;
exports.default = _default;